<template>
  <div class="qr-code">
    <div class="qr-code__inner" v-if="!shouldComponentUpdate && content">
      <canvas ref="qrCode" class="qr-code__code"></canvas>
    </div>

    <div v-else-if="shouldComponentUpdate">
      <canvas width="250" height="250"></canvas>
    </div>

    <div class="qr-code__inner" v-else-if="!content">
      <div class="qr-code__preview">
        <div class="icon-qr-preview text-color-space-light my-2" style="font-size: 200px;"></div>
      </div>
    </div>

    <div class="qr-code__loading" v-if="loading">
      <div class="qr-code__loading-bg"></div>
      <spinner class="qr-code__spinner" width="5" height="5"></spinner>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

import Spinner from '@/ui/elements/Spinner'

export default {
  data () {
    return {
      shouldComponentUpdate: false
    }
  },

  components: {
    Spinner
  },

  props: {
    content: {
      type: String,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    generate () {
      if (this.content) {
        QRCode.toCanvas(this.$refs.qrCode, this.content, {
          width: 250
        }, function (error) {
          if (error) console.error(error)
        })
      }
    }
  },

  mounted () {
    this.generate()
  },

  watch: {
    content () {
      this.shouldComponentUpdate = true
      setTimeout(() => {
        this.shouldComponentUpdate = false
        this.$nextTick(() => {
          this.generate()
        })
      }, 10)
    }
  }
}
</script>

<style lang="scss">
.qr-code {
  position: relative;

  &__code {
    width: 25rem;
    height: 25rem;
  }

  &__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: $color-white;
      opacity: .9;
    }
  }

  &__spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
